import type { MixedDressingDetails } from '@sg/graphql-schema';

import { getDressingPortionSize } from './get-dressing-portion-size';

import type { Modification } from '../../types';

// ─────────────────────────────────────────────────────────────────────────────

export function calculateMixedDressingCalories(
  modification: Modification,
  mixedDressingDetails: MixedDressingDetails[],
) {
  const { ingredient } = modification;

  if (!ingredient) {
    return 0;
  }

  const portionSize = getDressingPortionSize(modification, mixedDressingDetails); // prettier-ignore
  const ingredientCalories = ingredient.calories ?? 0;

  return ingredientCalories * portionSize;
}
